import scrollToElement from '../services/scrollService';

export default function businessCardScroll() {
    const businessCardWrap = document.querySelector('.js-business-card-wrapper');
    const businessCardAnchor = document.querySelector('.js-contact-anchor');

    if (!businessCardWrap) {
        return;
    }

    const businessCardTrigger = businessCardWrap.querySelectorAll('.js-business-card-trigger');

    businessCardTrigger.forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            scrollToElement(businessCardAnchor);
        }, false);
    });
}
window.addEventListener('load', businessCardScroll);
